<template>
  <div class="minwidth w100 mw100" style="background-color: #151419;">
    <tabbar></tabbar>

    <div>
      <div class="positionrel w100">
        <img style="width: 100%;height: auto;-webkit-filter: contrast(90%);filter: contrast(90%);"
          :src="require('../../public/img/consultation/consultation_banner.png')" />
      </div>

      <div class="pcScreen">
        <div
          style="display: flex;flex-wrap: wrap;justify-content: center;padding-bottom: 3%;width: 95%;margin: 0 auto;">
          <div v-for="(item,index) in partList" :key="index" style="width: 25%;padding: 1% 0;">
            <div
              style="width: 90%;margin: 0 auto;box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);border-radius: 0.5em;background-color: #fff;position: relative;margin-top: 10%;">
              <div>
                <img style="width: 100%;display: block;border-radius: 0.5em;" :src="item.url" alt="">
              </div>
              <div style="position: absolute;left: 50%;transform: translate(-50%);bottom: 10%;width: 100%;">
                <div style="display: flex;justify-content: end;width: 100%;margin: 0 auto;cursor: pointer;">
                  <div
                    style="width: 60%;margin: 0 auto;border-radius: 0.5em;line-height: 2;color: #fff;text-align: center;font-size: max(9px,0.9vw);background-color: #c5b497;"
                    @click="gotoLogin">*50元注册立即学习</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobileScreen">
        <div
          style="display: flex;flex-wrap: wrap;justify-content: center;padding-bottom: 3%;width: 95%;margin: 0 auto;">
          <div v-for="(item,index) in partList" :key="index" style="width: 50%;padding: 1% 0;">
            <div
              style="width: 90%;margin: 0 auto;box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);border-radius: 0.5em;background-color: #fff;position: relative;margin-top: 10%;">
              <div>
                <img style="width: 100%;display: block;border-radius: 0.5em;" :src="item.url" alt="">
              </div>
              <div style="position: absolute;left: 50%;transform: translate(-50%);bottom: 10%;width: 100%;">
                <div style="display: flex;justify-content: end;width: 100%;margin: 0 auto;cursor: pointer;">
                  <div
                    style="width: 60%;margin: 0 auto;border-radius: 0.5em;line-height: 2;color: #fff;text-align: center;font-size: 1.8vw;background-color: #c5b497;"
                    @click="gotoLogin">*50元注册立即学习</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <bottom></bottom>

    <!-- <customerservice></customerservice> -->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        partList: [{
          title: '一图看懂生活服务周边爆品打造核心要点及热点趋势',
          url: require('../../public/img/consultation/consultation_part1.png'),
        }, {
          title: '做好内容和营销，激发品牌搜索新增量',
          url: require('../../public/img/consultation/consultation_part2.png'),
        }, {
          title: '快消品牌鏖战，用好经营策略，才能降本增效、四两拨千斤。',
          url: require('../../public/img/consultation/consultation_part3.png'),
        }, {
          title: '助力企业在货架场、自播、短视频、达播、广告营销等方面快速转化跃迁，实现GMV的快速提升！',
          url: require('../../public/img/consultation/consultation_part4.png'),
        }, {
          title: '当您店铺推出有价格优势的商品，又担心被黄牛党扫货，怎么办？怎么办？怎么办？',
          url: require('../../public/img/consultation/consultation_part5.png'),
        }, {
          title: '什么是商品价格力，如何提升商品价格力',
          url: require('../../public/img/consultation/consultation_part6.png'),
        }, {
          title: '大健康风潮下，消费需求延展，新健康、新味觉、新熟品、新包装等新形态如何快速迭代。',
          url: require('../../public/img/consultation/consultation_part7.png'),
        }, {
          title: '如何提前预知哪类商品卖得好、哪些内容能成爆款？',
          url: require('../../public/img/consultation/consultation_part8.png'),
        }]
      };
    },

    methods: {
      routerPush(num) {
        this.$router.push({ path: '/trendsNum', query: { id: num } })
      },
      gotoJoin() {
        this.$router.push({ path: '/join' })
      },
      gotoLogin() {
        this.$router.push({ path: '/login' })
      }
    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .w100 {
    width: 100%;
  }

  .minwidth {
    min-width: 1000px;
  }

  .positionrel {
    position: relative;
    overflow: hidden;
  }

  .pcScreen {
    display: block;
  }

  .mobileScreen {
    display: none;
  }

  @media screen and (max-width: 750px) {
    .pcScreen {
      display: none;
    }

    .mobileScreen {
      display: block;
    }

    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }
  }
</style>